import { cn } from '@/lib/utils';

export default function H2({ children, className }: { children: string; className?: string }) {
    return <h2 className={cn('text-h4 font-medium lg:text-h2 lg:font-normal', className)}>{children}</h2>;
}
